import SearchUsers from "./components/SearchUsers/SearchUsers";

export default SearchUsers;
